<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-image-multiple</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.gallery') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <h5 style="font-size: 14px;color: rgba(0, 0, 0, 0.87);">{{ $t('gallery.maxInfo') }}</h5>
    </v-toolbar>
    <v-layout wrap
      v-show="!collapseContent"
    >
      <v-flex xs6>
        <v-checkbox
          v-model="content.GallerySlider"
          label="slider"
        />
      </v-flex>
      <v-flex xs6>
        <v-text-field
          v-show="content.GallerySlider"
          v-model="content.GalleryMobileHeight"
          append-icon="mdi-search"
          label="Forzar altura (solo móviles)"
          hideDetails
          @input="handleChangeIsModified"
        />
      </v-flex>
    </v-layout>

    <multi-select-image
      v-show="!collapseContent"
      :limit="12"
      :closed="true"
      :onAddImage="handleAddImageToGallery"
      :onClearImage="handleDeleteImageToGallery"
      :enterpriseID="enterpriseID"
      v-model="content.Images"
    />
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import MultiSelectImage from './MultiSelectImage'
  export default {
    components: {
      MultiSelectImage
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      }
    },
    methods: {
      handleAddImageToGallery (url) {
        this.content.Images.push(url)
      },
      handleDeleteImageToGallery (url) {
        this.content.Images = this.content.Images.filter(x => x !== url)
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>

<style scoped>
</style>

